export default __webpack_public_path__ + "static/patcheze-f2526ef90f7b2f62ced5cac6ce380cd8.png";